import { NextPageContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import Home from 'pages/index';
import { useEffect } from 'react';
import { getWithDomain } from 'services/EnvProvider';
import Cookies from 'universal-cookie';
import { hasCookieBannerInteraction } from 'utils/hasCookieBannerInteraction';
import { dayInSeconds } from 'utils/timeConst';

const Ref = () => {
  const { query } = useRouter();

  useEffect(() => {
    const referralUser = query?.user;

    if (referralUser && hasCookieBannerInteraction()) {
      new Cookies().set('sm_user_referral', referralUser, {
        path: '/',
        secure: process.env.NEXT_PUBLIC_ENV !== 'local',
        domain:
          process.env.NEXT_PUBLIC_ENV === 'local'
            ? 'localhost'
            : getWithDomain('.simplemining.net'),
        maxAge: 30 * dayInSeconds,
      });

      fetch(`/api/referral?user=${referralUser}`);
    }
  }, [query?.user]);

  return <Home />;
};

export async function getStaticProps(context: NextPageContext) {
  const { locale = 'en' } = context;

  return {
    props: await serverSideTranslations(locale),
  };
}

export default Ref;
